/**
 * API service
 */
import * as products from "./products.js";
import * as blogPosts from "./blog-posts.js";
import * as orders from "./orders.js";
import * as content from "./content.js";
import * as reviews from "./reviews.js";
import * as upload from "./upload.js";
import * as paypal from "./paypal.js";
import * as cartUtils from "../../utils/cartUtils.js";
import * as cartValidation from "../../utils/cartUtils.js";

export { getBaseURL, getHeaders, API_BASE_URL } from "./client.js";

const apiService = {
  ...products,
  ...blogPosts,
  ...orders,
  ...content,
  ...reviews,
  ...upload,
  ...paypal,
  ...cartUtils,
  ...cartValidation,
};

export default apiService;
